import React from 'react'

function ErrorPage() {

    return (
        <div className="errorpage">
            <p class="error"> Az oldal megtekintéséhez nincs jogosultsága. </p>
        </div>
    )

}

export default ErrorPage;
